import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Users } from "lucide-react";
import ClientsTab from "@/features/ventes/components/clients/ClientsTab";

export const Route = createFileRoute("/_app/ventes/clients/")({
  loader: requirePermission(PERMISSIONS.VENTES.CLIENTS.VIEW),
  staticData: {
    title: "Clients",
    icon: Users,
    tab_icon: Users,
    permission: PERMISSIONS.VENTES.CLIENTS.VIEW,
    module: "ventes",
    order: 10,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Gestion des clients",
  },
  component: ClientsTab,
});
